import React from 'react'
import { Tabs } from 'antd'
import { staffRemindersMockData } from './utils/mockdata'
import useReminderFilters from './hooks/useReminderFilters'
import useReminderModal from './hooks/useReminderModal'
import RemindersHeader from './Components/RemindersHeader'
import ReminderFilters from './Components/ReminderFilters'
import ReminderTable from './Components/ReminderTable'
import ReminderCardList from './Components/ReminderCardList'
import CreateReminderModal from './Components/CreateReminderModal'

const { TabPane } = Tabs

const StaffReminders = () => {
  // Use custom hooks
  const {
    filterValues,
    filteredData,
    upcomingReminders,
    pastReminders,
    searchText,
    setSearchText,
    categoryFilter,
    setCategoryFilter,
    priorityFilter,
    setPriorityFilter,
    acknowledgedFilter,
    setAcknowledgedFilter
  } = useReminderFilters(staffRemindersMockData)

  const { isModalVisible, form, showModal, handleCancel, handleAdd, handleAcknowledge, handleEdit, handleDelete } =
    useReminderModal()

  // Combine all filter state for passing to components
  const filterState = {
    searchText,
    setSearchText,
    categoryFilter,
    setCategoryFilter,
    priorityFilter,
    setPriorityFilter,
    acknowledgedFilter,
    setAcknowledgedFilter
  }

  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <RemindersHeader onCreateReminder={showModal} />

      {/* Filters */}
      <ReminderFilters filterValues={filterValues} filterState={filterState} />

      {/* Tabs and Tables */}
      <Tabs defaultActiveKey='upcoming'>
        <TabPane tab={`Upcoming Reminders (${upcomingReminders.length})`} key='upcoming'>
          <ReminderCardList reminders={upcomingReminders} onAcknowledge={handleAcknowledge} onEdit={handleEdit} />
        </TabPane>

        <TabPane tab={`Past Reminders (${pastReminders.length})`} key='past'>
          <ReminderTable
            data={pastReminders}
            showTimeUntil={false}
            onAcknowledge={handleAcknowledge}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </TabPane>

        <TabPane tab='Table View' key='table'>
          <ReminderTable
            data={filteredData}
            showTimeUntil={true}
            onAcknowledge={handleAcknowledge}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </TabPane>
      </Tabs>

      {/* Create Reminder Modal */}
      <CreateReminderModal
        isVisible={isModalVisible}
        onCancel={handleCancel}
        onAdd={handleAdd}
        form={form}
        filterValues={filterValues}
      />
    </div>
  )
}

export default StaffReminders
